import { StateType } from '#types';

export const selectAffiliateData = (state: StateType) => state.auth.profile;
